module.exports = __webpack_public_path__ + "img/frontier.d619b36e.png";